module.exports = __webpack_public_path__ + "img/IndicativoPagina.b872b744.png";